import styled from 'styled-components';
import React from 'react';
import { zIndexes } from '@styles/zindex/zindex';
import { TableProps } from './types';
import { Tr } from './Row/Tr';

function Table(props: TableProps) {
  const { children, ...rest } = props;

  return (
    <div {...rest}>
      <table>{children}</table>
    </div>
  );
}

const TableBase = styled(Table)`
  --heading-row-gap: 8px;
  --heading-padding-block: 8px;
  --heading-padding: var(--heading-padding-block) 0px;
  --heading-background: #fff;

  --row-gap: 12px;
  --row-left-padding: 8px;
  --row-right-padding: 8px;
  --row-block-padding: 8px;
  --row-border-radius: 8px;
  --row-bg: var(--beam-color-neutral-n100);
  --row-bg-hover: var(--beam-color-neutral-n200);

  --row-height: 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }

  /* Gap */
  table thead tr th {
    padding: 0;
    padding-bottom: var(--heading-row-gap);
    background-color: var(--heading-background);
  }

  table tbody tr td {
    padding: 0;
    padding-bottom: var(--row-gap);
  }
  table tbody tr:last-of-type > td {
    /* Take heading padding */
    padding-bottom: 0;
  }
  /* Content */
  table tbody tr td > .Table_content {
    background-color: var(--row-bg);

    padding-top: var(--row-block-padding);
    padding-bottom: var(--row-block-padding);
    padding-right: var(--row-right-padding);
    padding-left: var(--row-left-padding);

    height: var(--row-height);
  }

  table tbody tr[data-hovered='true'] > td > .Table_content {
    background-color: var(--row-bg-hover);
  }
  table tbody tr td:first-of-type > .Table_content {
    border-top-left-radius: var(--row-border-radius);
    border-bottom-left-radius: var(--row-border-radius);
  }
  table tbody tr td:not(:first-of-type) > .Table_content {
    padding-left: 0;
  }
  table tbody tr td:last-of-type > .Table_content {
    border-top-right-radius: var(--row-border-radius);
    border-bottom-right-radius: var(--row-border-radius);
  }

  /* Stick */
  table thead th {
    position: sticky;
    top: 0;
    z-index: ${zIndexes.indexOf('table-heading')};
  }
`;
const TableFilled = React.memo(TableBase) as unknown as React.FC<TableProps> & {
  Tr: typeof Tr;
};

TableFilled.Tr = Tr;

export default TableFilled;
